import { render, staticRenderFns } from "./patientRecord.vue?vue&type=template&id=73939d12&scoped=true"
import script from "./patientRecord.vue?vue&type=script&lang=js"
export * from "./patientRecord.vue?vue&type=script&lang=js"
import style0 from "./patientRecord.vue?vue&type=style&index=0&id=73939d12&prod&lang=scss&scoped=true"
import style1 from "./patientRecord.vue?vue&type=style&index=1&id=73939d12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73939d12",
  null
  
)

export default component.exports